import CardRankings from "../../../../src/components/card-rankings/CardRankings";
import otcRatings from "../../../../src/data/articles/cube-prospective-outlaws-of-thunder-junction-commander/otc-prospective-ratings.json";
import ProspectiveIntro from "../../../../src/components/article-elements/ProspectiveIntro.tsx";
import * as React from 'react';
export default {
  CardRankings,
  otcRatings,
  ProspectiveIntro,
  React
};